'use strict';

var _regeneratorRuntime = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _awaitAsyncGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var errCode = require('err-code');

var CID = require('cids');
/**
 * @typedef {Object} Pinnable
 * @property {string | InstanceType<typeof window.String> | CID} [path]
 * @property {CID} [cid]
 * @property {boolean} [recursive]
 * @property {any} [metadata]
 *
 * @typedef {CID|string|InstanceType<typeof window.String>|Pinnable} ToPin
 * @typedef {ToPin|Iterable<ToPin>|AsyncIterable<ToPin>} Source
 *
 * @typedef {Object} Pin
 * @property {string|CID} path
 * @property {boolean} recursive
 * @property {any} [metadata]
 */

/**
 * Transform one of:
 *
 * ```ts
 * CID
 * String
 * { cid: CID recursive, metadata }
 * { path: String recursive, metadata }
 * Iterable<CID>
 * Iterable<String>
 * Iterable<{ cid: CID recursive, metadata }>
 * Iterable<{ path: String recursive, metadata }>
 * AsyncIterable<CID>
 * AsyncIterable<String>
 * AsyncIterable<{ cid: CID recursive, metadata }>
 * AsyncIterable<{ path: String recursive, metadata }>
 * ```
 * Into:
 *
 * ```ts
 * AsyncIterable<{ path: CID|String, recursive:boolean, metadata }>
 * ```
 *
 * @param {Source} input
 * @returns {AsyncIterable<Pin>}
 */
// eslint-disable-next-line complexity


module.exports = /*#__PURE__*/function () {
  var _normaliseInput = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
    var iterator, first, _iterator3, _step3, cid, _iterator4, _step4, obj, _iterator5, _first, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _cid, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _obj;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(input === null || input === undefined)) {
              _context.next = 2;
              break;
            }

            throw errCode(new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');

          case 2:
            if (!CID.isCID(input)) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return toPin({
              cid: input
            });

          case 5:
            return _context.abrupt("return");

          case 6:
            if (!(input instanceof String || typeof input === 'string')) {
              _context.next = 10;
              break;
            }

            _context.next = 9;
            return toPin({
              path: input
            });

          case 9:
            return _context.abrupt("return");

          case 10:
            if (!(input.cid != null || input.path != null)) {
              _context.next = 14;
              break;
            }

            _context.next = 13;
            return toPin(input);

          case 13:
            return _context.abrupt("return", _context.sent);

          case 14:
            if (!(Symbol.iterator in input)) {
              _context.next = 62;
              break;
            }

            // @ts-ignore
            iterator = input[Symbol.iterator]();
            first = iterator.next();

            if (!first.done) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return", iterator);

          case 19:
            if (!(CID.isCID(first.value) || first.value instanceof String || typeof first.value === 'string')) {
              _context.next = 40;
              break;
            }

            _context.next = 22;
            return toPin({
              cid: first.value
            });

          case 22:
            _iterator3 = _createForOfIteratorHelper(iterator);
            _context.prev = 23;

            _iterator3.s();

          case 25:
            if ((_step3 = _iterator3.n()).done) {
              _context.next = 31;
              break;
            }

            cid = _step3.value;
            _context.next = 29;
            return toPin({
              cid: cid
            });

          case 29:
            _context.next = 25;
            break;

          case 31:
            _context.next = 36;
            break;

          case 33:
            _context.prev = 33;
            _context.t0 = _context["catch"](23);

            _iterator3.e(_context.t0);

          case 36:
            _context.prev = 36;

            _iterator3.f();

            return _context.finish(36);

          case 39:
            return _context.abrupt("return");

          case 40:
            if (!(first.value.cid != null || first.value.path != null)) {
              _context.next = 61;
              break;
            }

            _context.next = 43;
            return toPin(first.value);

          case 43:
            _iterator4 = _createForOfIteratorHelper(iterator);
            _context.prev = 44;

            _iterator4.s();

          case 46:
            if ((_step4 = _iterator4.n()).done) {
              _context.next = 52;
              break;
            }

            obj = _step4.value;
            _context.next = 50;
            return toPin(obj);

          case 50:
            _context.next = 46;
            break;

          case 52:
            _context.next = 57;
            break;

          case 54:
            _context.prev = 54;
            _context.t1 = _context["catch"](44);

            _iterator4.e(_context.t1);

          case 57:
            _context.prev = 57;

            _iterator4.f();

            return _context.finish(57);

          case 60:
            return _context.abrupt("return");

          case 61:
            throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 62:
            if (!(Symbol.asyncIterator in input)) {
              _context.next = 136;
              break;
            }

            // @ts-ignore
            _iterator5 = input[Symbol.asyncIterator]();
            _context.next = 66;
            return _awaitAsyncGenerator(_iterator5.next());

          case 66:
            _first = _context.sent;

            if (!_first.done) {
              _context.next = 69;
              break;
            }

            return _context.abrupt("return", _iterator5);

          case 69:
            if (!(CID.isCID(_first.value) || _first.value instanceof String || typeof _first.value === 'string')) {
              _context.next = 102;
              break;
            }

            _context.next = 72;
            return toPin({
              cid: _first.value
            });

          case 72:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 74;
            _iterator = _asyncIterator(_iterator5);

          case 76:
            _context.next = 78;
            return _awaitAsyncGenerator(_iterator.next());

          case 78:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 85;
              break;
            }

            _cid = _step.value;
            _context.next = 82;
            return toPin({
              cid: _cid
            });

          case 82:
            _iteratorAbruptCompletion = false;
            _context.next = 76;
            break;

          case 85:
            _context.next = 91;
            break;

          case 87:
            _context.prev = 87;
            _context.t2 = _context["catch"](74);
            _didIteratorError = true;
            _iteratorError = _context.t2;

          case 91:
            _context.prev = 91;
            _context.prev = 92;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 96;
              break;
            }

            _context.next = 96;
            return _awaitAsyncGenerator(_iterator.return());

          case 96:
            _context.prev = 96;

            if (!_didIteratorError) {
              _context.next = 99;
              break;
            }

            throw _iteratorError;

          case 99:
            return _context.finish(96);

          case 100:
            return _context.finish(91);

          case 101:
            return _context.abrupt("return");

          case 102:
            if (!(_first.value.cid != null || _first.value.path != null)) {
              _context.next = 135;
              break;
            }

            _context.next = 105;
            return toPin(_first.value);

          case 105:
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context.prev = 107;
            _iterator2 = _asyncIterator(_iterator5);

          case 109:
            _context.next = 111;
            return _awaitAsyncGenerator(_iterator2.next());

          case 111:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context.sent).done)) {
              _context.next = 118;
              break;
            }

            _obj = _step2.value;
            _context.next = 115;
            return toPin(_obj);

          case 115:
            _iteratorAbruptCompletion2 = false;
            _context.next = 109;
            break;

          case 118:
            _context.next = 124;
            break;

          case 120:
            _context.prev = 120;
            _context.t3 = _context["catch"](107);
            _didIteratorError2 = true;
            _iteratorError2 = _context.t3;

          case 124:
            _context.prev = 124;
            _context.prev = 125;

            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context.next = 129;
              break;
            }

            _context.next = 129;
            return _awaitAsyncGenerator(_iterator2.return());

          case 129:
            _context.prev = 129;

            if (!_didIteratorError2) {
              _context.next = 132;
              break;
            }

            throw _iteratorError2;

          case 132:
            return _context.finish(129);

          case 133:
            return _context.finish(124);

          case 134:
            return _context.abrupt("return");

          case 135:
            throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 136:
            throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 137:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[23, 33, 36, 39], [44, 54, 57, 60], [74, 87, 91, 101], [92,, 96, 100], [107, 120, 124, 134], [125,, 129, 133]]);
  }));

  function normaliseInput(_x) {
    return _normaliseInput.apply(this, arguments);
  }

  return normaliseInput;
}();
/**
 * @param {Pinnable} input
 */


function toPin(input) {
  var path = input.cid || "".concat(input.path);

  if (!path) {
    throw errCode(new Error('Unexpected input: Please path either a CID or an IPFS path'), 'ERR_UNEXPECTED_INPUT');
  }
  /** @type {Pin} */


  var pin = {
    path: path,
    recursive: input.recursive !== false
  };

  if (input.metadata != null) {
    pin.metadata = input.metadata;
  }

  return pin;
}